module.exports = __webpack_public_path__ + "img/carousel-1-old.59828ff8.jpg";